import TeamMemberVerification from "views/containers/team-management/verification";

const TeamInviteVerification = (): JSX.Element => {
  return <TeamMemberVerification />;
};

export default TeamInviteVerification;
